<body>
    <!--  Body Wrapper -->
    <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-navbarbg="skin6" data-sidebartype="full"
      data-sidebar-position="fixed" data-header-position="fixed">

      <div class="d-flex justify-content-end">
        <button (click)="close()" type="button" class="close" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="body-wrapper">
        <div class="container-fluid ">
          <div class="row">
            <div class="container my-4">

              <div class="align-items-center justify-content-between">

                <div class="card">

                  <div class="card-body">
                    <h5 id="upper" class="" style="color: black;">Informations coopérative</h5>
                    <div class="container mt-4">

                      <form>
                        <div class="row g-3">
                          <div class="col-12 col-md-4">
                            <label for="nom" class="form-label">Nom de la coopérative</label>
                            <input [(ngModel)]="item.nom" name="nom" type="text" class="form-control" id="nom"
                              placeholder="Nom de la coopérative">
                          </div>
                          <div class="col-12 col-md-4">
                            <label for="nom" class="form-label">Localisation</label>
                            <input [(ngModel)]="item.localisation" name="localisation" type="text" class="form-control"
                              id="localisation" placeholder="">
                          </div>
                          <div class="col-12 col-md-4">
                            <label for="nom" class="form-label">Longitude</label>
                            <input [(ngModel)]="item.longitude" name="longitude" type="number" class="form-control"
                              id="longitude" placeholder="">
                          </div>
                          <div class="col-12 col-md-4">
                            <label for="nom" class="form-label">Latitude </label>
                            <input [(ngModel)]="item.latitude" name="latitude" type="number" class="form-control"
                              id="latitude" placeholder="">
                          </div>
                          <div class="col-12 col-md-4">
                            <label for="nom" class="form-label">Description </label>
                            <textarea [(ngModel)]="item.description" rows="1" name="description" type="text"
                              class="form-control" id="description" placeholder="">
                            </textarea>
                          </div>

                          <!-- <div class="col-12 col-md-4">
                            <label for="nom" class="form-label">Administrateur </label>
                            <select [(ngModel)]="item.admin_id"  name="admin_id"class="form-select" id="admin_id">
                              <option *ngFor="let item of adminItems " [value]="item.reference"> {{item.nom}}</option>
                            </select>
                          </div> -->

                        </div>
                        <div class="d-flex justify-content-end mt-4">
                          <a  title="Cliquez ici pour annuler " href="javascript: void(0);" (click)="close()"
                          class="btn btn-secondary me-3"
                          style="color: white; border: none; font-weight: 800; font-size: 16px; height: 38px; border-radius: 5px; display: flex; align-items: center; justify-content: center;">
                          Annuler &nbsp;
                        </a>

                          <a (click)="updateCooperative()" title="Cliquez ici pour enregistrer " href="javascript: void(0);"
                             class="btn"
                            style="color: white; background-color: #578D63; border: none; font-weight: 800; font-size: 16px; height: 38px; border-radius: 5px; display: flex; align-items: center; justify-content: center;">
                            Enregistrer &nbsp;<i class="pi pi-save" style="font-size: 1rem"></i>
                          </a>
                        </div>


                      </form>

                    </div>


                  </div>
                </div>
              </div>



            </div>

          </div>
        </div>
      </div>
    </div>

  </body>
